/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingoverviewempty2Inputs */

const en_crosspostingoverviewempty2 = /** @type {(inputs: Crosspostingoverviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts yet`)
};

const de_crosspostingoverviewempty2 = /** @type {(inputs: Crosspostingoverviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Beiträge`)
};

/**
* | output |
* | --- |
* | "No posts yet" |
*
* @param {Crosspostingoverviewempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingoverviewempty2 = /** @type {((inputs?: Crosspostingoverviewempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingoverviewempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingoverviewempty2(inputs)
	return de_crosspostingoverviewempty2(inputs)
});
export { crosspostingoverviewempty2 as "crosspostingOverviewEmpty" }